module.exports = {"stepOfSteps":"Step [activeStep] of [stepsTotal]"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Stepper/localization/en-GB/strings.json
// module id = 1241
// module chunks = 0